// 신규 신청 상세 - 해당하는 경매건의 정보를 리턴
const selectAuction = (auctions, displayAuctionId) => {
	if (!auctions?.length) return null;
	return auctions.find(({ auctionId }) => auctionId === displayAuctionId) || auctions[0];
};

export default function convertSellerBidsDetail(data) {
	if (!data) return {};

	const { auctions, displayAuctionId } = data;
	const auction = selectAuction(auctions, displayAuctionId);
	const deal = auction?.deal;

	return {
		...data,
		auctionId: auction?.auctionId,
		isPossibleChoiceBid: auction?.isPossibleChoiceBid,
		dealerBids: auction?.dealerBids || [],
		auctionStartDtm: auction?.startDtm,
		auctionEndDtm: auction?.endDtm,
		bidChoiceEndDtm: auction?.bidChoiceEndDtm,
		periodExtendCount: auction?.periodExtendCount,
		dealerSafeNumber: deal?.dealerSafeNumber,
		reductionPrice: deal?.reductionPrice,
		dealReductions: deal?.dealReductions,
		isDealFinish: deal?.isDealFinish,
		isDealerDealCancel: deal?.isDealCancel,
		isWriteReview: deal?.isWriteReview,
		isResponsiblePurchaseAgree: deal?.isResponsiblePurchaseAgree,
		dealCoordinationForSellerResponse: deal?.coordination,
	};
}
